export default __webpack_public_path__ + "static/media/driver.7755f6e7.svg";